import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { ListFile } from "../../../../../components/listas/ListFile";
import { URL_CONCESIONARIOS } from "../../../../../constants/url";
import { startEliminaDocumentoConcesionario } from "../../../../../context/actions/concesionariosActions";
import { startDownloadFile } from "../../../../../context/actions/genericoActions";

export const Listado = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const { documentos } = useSelector(
    (state) => state.concesionariosReducer.concesionariosServicio
  );

  const handleClick = (doc) => {
    const url = `${URL_CONCESIONARIOS}/GetDocumento/${doc.id}`;
    dispatch(startDownloadFile(url, doc.nombreArchivo));
  };

  const handleDelete = (doc) => {
    dispatch(startEliminaDocumentoConcesionario(doc.id, id));
  };

  return (
    <div>
      {documentos.map((d, i) => (
        <ListFile
          key={d.id}
          doc={d}
          onClick={handleClick}
          onDelete={handleDelete}
        />
      ))}
    </div>
  );
};
